import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

/**
 * Declara una pantalla de ruta con carga diferida a partir de un export **con
 * nombre**.
 *
 * `React.lazy` exige que el módulo resuelva a `{ default }`, y casi todas las
 * pantallas de `protectedRoutes` se exportan con nombre. Este helper hace esa
 * adaptación en un solo sitio en lugar de repetir el `.then(...)` un centenar de
 * veces.
 *
 * @example
 * const Orders = lazyNamed(() => import('@modules/Orders/List'), 'Orders');
 * // la entrada de la ruta no cambia: element: <Orders />
 */
export function lazyNamed(
  loader: () => Promise<Record<string, unknown>>,
  exportName: string,
): LazyExoticComponent<ComponentType<unknown>> {
  return lazy(async () => {
    const module = await loader();
    const component = module[exportName];

    if (!component) {
      throw new Error(`El módulo cargado no exporta '${exportName}'`);
    }

    return { default: component as ComponentType<unknown> };
  });
}
